import { Reveal } from "@/components/site/Reveal";

export const IntroStatement = () => (
  <section className="bg-background" data-testid="intro-section">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 py-20 lg:grid-cols-12 lg:px-10 lg:py-28">
      <Reveal className="lg:col-span-7">
        <p className="font-serif-accent text-2xl font-medium leading-snug text-foreground sm:text-3xl lg:text-[34px]">
          „Kvalitní rekonstrukce začíná pečlivou přípravou. Dbáme na správné
          technologické postupy, kvalitní materiály a precizní provedení
          každého detailu.“
        </p>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-muted-foreground">
          Každou zakázku nejprve prohlédneme, navrhneme vhodné řešení
          a připravíme přehlednou cenovou nabídku. Rekonstrukci provedeme
          kvalitně, v dohodnutém termínu a s důrazem na dlouhou životnost.
        </p>
      </Reveal>
      <Reveal delay={0.15} className="lg:col-span-5">
        <figure>
          <img
            src="./images/fasada-detail-sokl.jpg"
            alt="Detail provedení fasády a soklu"
            className="h-64 w-full rounded-md object-cover lg:h-72"
            loading="lazy"
          />
          <figcaption className="mt-2 text-xs text-muted-foreground">
            Detail provedení · fasáda a sokl
          </figcaption>
        </figure>
      </Reveal>
    </div>
  </section>
);
